import { render, staticRenderFns } from "./CtrlRegionaisPage.vue?vue&type=template&id=c0786b3a"
import script from "./CtrlRegionaisPage.vue?vue&type=script&lang=js"
export * from "./CtrlRegionaisPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports